// Chart colors for the billing pages, each set run through the dataviz palette
// validator against the card surface (gray-800, #1f2937) rather than picked by
// eye:
//
//   revenue type  categorical — violet, aqua, orange; passes the colorblind
//                 separation and contrast checks in this order.
//   plan          ordinal — one violet ramp, brighter for the higher tier, since
//                 the tiers are ordered and the color should say so.
//   aging         the reserved status colors, always beside a written label.
import { DATA_HUE } from '../dashboard/theme';

export const TYPE_COLORS = {
  subscription: '#9085e9',
  usage: '#199e70',
  guests: '#d95926',
};

export const PLAN_COLORS = {
  starter: '#7c3aed',
  pro: '#a78bfa',
  enterprise: '#ddd6fe',
};

export const AGING_COLORS = {
  current: DATA_HUE,
  '1-30': '#fab219',
  '31-60': '#ec835a',
  '61-90': '#d03b3b',
  '90+': '#d03b3b',
};

// Cash collected rides over the billed columns as a light line, so it never
// reads as one more stacked part of the bill.
export const COLLECTED_COLOR = '#e5e7eb';

export const SURFACE = '#1f2937';

export const seriesColor = (breakdown, id) =>
  (breakdown === 'plan' ? PLAN_COLORS : TYPE_COLORS)[id] || DATA_HUE;

// A clean axis top in cents: $1, $1.5, $2, $2.5, $3, $4, $5, $6, $8 times a
// power of ten, so the top tick and the midpoint both read as round amounts.
export const niceMoneyCeil = (cents) => {
  const dollars = Math.max(1, cents / 100);
  const power = 10 ** Math.floor(Math.log10(dollars));
  const step = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10].find((m) => m * power >= dollars);
  return Math.round(step * power * 100);
};
